module.exports = __webpack_public_path__ + "img/6.85e229d1.jpg";